import _ from 'lodash';
import React from 'react';

import {formatDate} from 'utils/datetime';

import ButtonDropdown from 'components/ButtonDropdown';

// TODO: Replace `png` with `svg`
import helloSignLogo from './assets/hellosign.png';

import './styles.css';

const BaseInformation = ({
  agreementTypeName,
  openSendAgreementReminderModal,
  openCancelAgreementModal,
  openSendAgreementModal,
  openSignAgreementManuallyModal,
  contractUrl,
  sentAt,
  agreementId,
  canBeSent,
  canBeReminded,
  canBeSignedManually,
  canBeCancelled,
  downloadAgreement
}) => (
  <div className="BaseInformation">
    <div className="name">
      <img className="avatar" src={helloSignLogo} alt="HelloSign logo" />
      <div className="info">
        <div className="heading">
          <div>{agreementTypeName} Agreement</div>
        </div>
        <div className="sentAt">
          {sentAt && `Sent ${formatDate(sentAt)}`}
          {!sentAt && 'Not sent yet'}
        </div>
      </div>
    </div>

    <ButtonDropdown title="Agreement options">
      <ButtonDropdown.Option
        disabled={!canBeSent}
        onClick={() => openSendAgreementModal(agreementId)}>
        Send signature request
      </ButtonDropdown.Option>
      <ButtonDropdown.Option
        disabled={!canBeReminded}
        onClick={() => openSendAgreementReminderModal(agreementId)}>
        Send reminder
      </ButtonDropdown.Option>
      <ButtonDropdown.Option
        disabled={!canBeSignedManually}
        onClick={() => openSignAgreementManuallyModal(agreementId)}>
        Sign manually
      </ButtonDropdown.Option>
      <ButtonDropdown.Option
        disabled={_.isNil(contractUrl)}
        onClick={() => downloadAgreement(contractUrl)}>
        Download
      </ButtonDropdown.Option>
      <ButtonDropdown.Option
        disabled={!canBeCancelled}
        onClick={() => openCancelAgreementModal(agreementId)}>
        Cancel
      </ButtonDropdown.Option>
    </ButtonDropdown>
  </div>
);

export default BaseInformation;
